export enum PAGES {
    RENAME = 'rename',
    ARCHIVE = 'archive',
}

export const MAX_CLASS_NAME_LENGTH = 6;

export const CLASS_GRADES_TO_ARCHIVE = [5, 7, 9, 10, 11, 99];
